const Referral = () => import('~pages/Referral/Referral.vue')

export default [
  {
    name: 'referral',
    path: '/referral',
    component: Referral,
    meta: {
      bypassToken: true
    }
  }
]
